import $ from 'jquery';
import core from '../core';

let $window = null;
let $headerEl = null;

const componentSelector = '.js-header-search';

function bindEvents() {
    $(document.body).on('submit', componentSelector, onFormSubmit);
}

function setup() {
   bindEvents();
}

function onFormSubmit(evt) {
    const $form = $(evt.target);
    const $formSearchField = $form.find('.js-header-search__field');

    if (window.matchMedia('(max-width: 1024px)').matches
        || $form.hasClass('is--shown')) {
        return;
    }

    evt.preventDefault();

    $form.toggleClass('is--shown');

    if ($form.hasClass('is--shown')) {
        setTimeout(() => {
            $formSearchField.focus();
        }, 350);
    } else {
        $formSearchField.blur();
    }
}

core.Ready(setup);
